import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { experimentalStyled as styled } from '@mui/material/styles'
import { safeJsonParse } from '../../utils/jsonUtils'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import { Button } from '@mui/material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import Table from '@mui/material/Table'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import CircularProgress from '@mui/material/CircularProgress'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import axios from '../../api/axios'
import toast from 'react-hot-toast'
import { useEffect, useState } from 'react'
import DOMPurify from 'dompurify'

const columns = [
   { id: 'orderId',     label: 'Order ID',     minWidth: 120 },
   { id: 'vehicletype', label: 'Vehicle Type', minWidth: 150 },
   { id: 'VINnumber',   label: 'Reg Number',   minWidth: 120 },
   { id: 'createdAt',   label: 'Created',      minWidth: 120 },
   { id: 'updatedAt',   label: 'Updated',      minWidth: 120 },
   { id: 'status',      label: 'Status',       minWidth: 50, align: 'center' },
]

const Item1 = styled(Paper)(({ theme }) => ({
   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
   ...theme.typography.body2,
   padding: '20px 20px 20px 20px',
   height: '100%',
   display: 'flex',
   flexDirection: 'column',
   gap: '10px',
   textAlign: 'center',
   borderLeft: '5px solid #FA870B',
   color: theme.palette.text.secondary,
}))
const Item2 = styled(Paper)(({ theme }) => ({
   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
   ...theme.typography.body2,
   padding: '20px 20px 20px 20px',
   height: '100%',
   display: 'flex',
   flexDirection: 'column',
   gap: '10px',
   textAlign: 'center',
   borderLeft: '5px solid #ffc800',
   color: theme.palette.text.secondary,
}))
const Item3 = styled(Paper)(({ theme }) => ({
   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
   ...theme.typography.body2,
   padding: '20px 20px 20px 20px',
   height: '100%',
   display: 'flex',
   flexDirection: 'column',
   gap: '10px',
   textAlign: 'center',
   borderLeft: '5px solid #01ef92',
   color: theme.palette.text.secondary,
}))

export default function Dashboard() {
   const [account, setAccount] = useState(null);
   const [allData, setAllData] = useState([])
   const [openTime, setOpenTime] = useState('')
   const [closeTime, setCloseTime] = useState('')
   const [creditAmount, setCreditAmount] = useState(0)
   const [userType, setUserType] = useState('')
   const [newsContent, setNewsContent] = useState('')
   const [isLoading, setIsLoading] = useState(false)

   useEffect(()=>{
      const user = localStorage.getItem('user');
      if(user){
         let parse = safeJsonParse(user);
         setAccount(parse);
      }
   },[]);

   const navigate = useNavigate()
   const customTime = (date) => {
      const d = new Date(date)
      let hour = d.getHours()
      let minute = d.getMinutes()
      if (hour < 10) hour = '0' + hour
      if (minute < 10) minute = '0' + minute
      return `${hour}:${minute}`
   }
   const getDataByFilter = async (id) => {
      try {
         setIsLoading(true)
         await axios
            .post(`getDataByFilter`, {
               filter: 'all',
               id,
            })
            .then((result) => {
               if (result.data.status) {
                  const sorted = [...result.data.data].sort((a, b) => Number(b.orderId) - Number(a.orderId))
                  setAllData(sorted)
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      } finally {
         setIsLoading(false)
      }
   }
   const getServiceTime = async () => {
      const weekdaylist = [
         'Sunday',
         'Monday',
         'Tuesday',
         'Wednesday',
         'Thursday',
         'Friday',
         'Saturday',
      ]
      const d = new Date()
      const day = weekdaylist[d.getDay()]

      try {
         await axios
            .post(`getServiceTime`, { day })
            .then((result) => {
               if (result.data.status) {
                  if (result.data.data.open === '--:--:--') {
                     setOpenTime('Fileservice is closed')
                     setCloseTime('Fileservice is closed')
                  } else {
                     setOpenTime(customTime(result.data.data.open))
                     setCloseTime(customTime(result.data.data.close))
                  }
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const getSumCredit = async (id) => {
      try {
         await axios
            .post(`getSumCredit`, { id })
            .then((result) => {
               if (result.data.status) {
                  setCreditAmount(result.data.data)
               } else {
                  toast.error(result.data.data)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const getUserType = async (id) => {
      try {
         await axios
            .post(`getUserType`, {
               id: id,
            })
            .then((result) => {
               if (result.data.type) {
                  setUserType(result.data.type)
               }
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   const getContents = async () => {
      try {
         await axios
            .post(`getContents`)
            .then((result) => {
               setNewsContent(DOMPurify.sanitize(result.data.new))
            })
      } catch (error) {
         if (process.env.REACT_APP_MODE) console.log(error)
         toast.error('Ett fel uppstod. Försök igen.')
      }
   }

   useEffect(() => {
      if (account) {
         getContents()
         getDataByFilter(account?._id)
         getServiceTime()
         getSumCredit(account?._id)
         getUserType(account?._id)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [account])

   return (
      <Box
         sx={{
            flexGrow: 1,
            p: 3,
            bgcolor: 'rgb(229, 229, 229)',
            overflowY: 'auto',
         }}
      >
         <Box sx={{ mt: '80px' }}>
            <Grid
               container
               spacing={{ xs: 2, md: 3 }}
               columns={{ xs: 4, sm: 8, md: 12 }}
            >
               {userType === 'user' && ( <>
               <Grid item xs={6} sm={4} md={4}>
                  <Item1>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h3 style={{ margin: '0px' }}>Credit</h3>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h2 style={{ margin: '0px' }}>{creditAmount}</h2>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <Button
                           variant="contained"
                           onClick={() => navigate('/buyCredit')}
                        >
                           Buy Now
                        </Button>
                     </Box>
                  </Item1>
               </Grid>
               </>)}
               <Grid item xs={6} sm={4} md={4}>
                  <Item2>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h3 style={{ margin: '0px' }}>Opening Time</h3>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h2 style={{ margin: '0px' }}>{openTime}</h2>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     ></Box>
                  </Item2>
               </Grid>
               <Grid item xs={6} sm={4} md={4}>
                  <Item3>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h3 style={{ margin: '0px' }}>Closing Time</h3>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     >
                        <h2 style={{ margin: '0px' }}>{closeTime}</h2>
                     </Box>
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'flex-start',
                        }}
                     ></Box>
                  </Item3>
               </Grid>
            </Grid>
         </Box>
         <Box sx={{ mt: '30px' }}>
            <Grid
               container
               spacing={{ xs: 2, md: 3 }}
               columns={{ xs: 4, sm: 8, md: 12 }}
            >
               <Grid item xs={12} sm={12} md={12}>
                  <Item2>
                     <Grid
                        container
                        spacing={{ xs: 2, md: 3 }}
                        columns={{ xs: 4, sm: 8, md: 12 }}
                     >
                        <Grid item xs={12} sm={12} md={6}>
                           <Box
                              sx={{
                                 display: 'flex',
                                 justifyContent: 'flex-start',
                              }}
                           >
                              <h3 style={{ margin: '0px' }}>Uploaded Files</h3>
                           </Box>
                           <Box
                              sx={{
                                 marginTop: '20px',
                                 display: 'flex',
                                 justifyContent: 'flex-start',
                                 border: '1px dotted',
                                 borderRadius: '20px',
                                 flexDirection: 'column',
                                 p: '30px',
                                 gap: '10px',
                              }}
                           >
                              <Box>
                                 <CloudUploadIcon
                                    sx={{
                                       color: '#FA870B',
                                       fontSize: '70px',
                                    }}
                                 />
                              </Box>
                              <Box>Click to Upload File</Box>
                              <Box>
                                 <Button
                                    variant="outlined"
                                    sx={{
                                       border: '1px solid #FA870B',
                                       borderRadius: '12px',
                                       color: '#FA870B',
                                    }}
                                    onClick={() => navigate('/upload')}
                                 >
                                    Browse File
                                 </Button>
                              </Box>
                           </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                           <Box
                              sx={{
                                 display: 'flex',
                                 alignItems: 'flex-start',
                                 flexDirection: 'column',
                              }}
                           >
                              <h4 style={{ margin: '0px' }}>Recent Files</h4>
                           </Box>
                           <Box
                              sx={{
                                 marginTop: '20px',
                                 display: 'flex',
                                 justifyContent: 'flex-start',
                                 flexDirection: 'column',
                              }}
                           >
                              {isLoading ? (
                                 <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                                    <CircularProgress />
                                 </Box>
                              ) : allData.length > 0 ? (
                                 <TableContainer
                                    component={Paper}
                                    style={{
                                       overflowY: 'auto',
                                       height: '260px',
                                    }}
                                 >
                                    <Table
                                       sx={{ width: '100%' }}
                                       aria-label="simple table"
                                    >
                                       <TableHead>
                                          <TableRow>
                                             {columns.map((column) => (
                                                <TableCell
                                                   key={column.id}
                                                   align={column.align}
                                                   style={{
                                                      minWidth: column.minWidth,
                                                   }}
                                                >
                                                   {column.label}
                                                </TableCell>
                                             ))}
                                          </TableRow>
                                       </TableHead>
                                       <TableBody>
                                          {allData.map((row) => (
                                             <TableRow
                                                key={row._id}
                                                sx={{
                                                   '&:last-child td, &:last-child th':
                                                      {
                                                         border: 0,
                                                      },
                                                }}
                                             >
                                                <TableCell
                                                   component="th"
                                                   scope="row"
                                                >
                                                   {row.orderId}
                                                </TableCell>
                                                <TableCell align="left">
                                                   {row.vehicleType}
                                                </TableCell>
                                                <TableCell align="left">
                                                   {row.VINnumber}
                                                </TableCell>
                                                <TableCell align="left">
                                                   {row.createdAt}
                                                </TableCell>
                                                <TableCell align="left">
                                                   {row.updatedAt}
                                                </TableCell>
                                                <TableCell align="center">
                                                   <span
                                                      className={
                                                         row.status === 'Requested' ? 'request-status' :
                                                         row.status === 'Completed' ? 'success-status' :
                                                         row.status === 'Cancelled' ? 'cancel-status'  :
                                                         'progress-status'
                                                      }
                                                      onClick={() =>
                                                         navigate('/overview')
                                                      }
                                                   >
                                                      {row.status}
                                                   </span>
                                                </TableCell>
                                             </TableRow>
                                          ))}
                                       </TableBody>
                                    </Table>
                                 </TableContainer>
                              ) : (
                                 <Box
                                    sx={{
                                       display: 'flex',
                                       flexDirection: 'column',
                                       m: '40px',
                                       alignItems: 'center',
                                    }}
                                 >
                                    <InsertDriveFileIcon
                                       sx={{ fontSize: '60px' }}
                                    />
                                    No recent file
                                 </Box>
                              )}
                           </Box>
                        </Grid>
                     </Grid>
                  </Item2>
               </Grid>
            </Grid>
         </Box>
         <Box sx={{ mt: '30px' }}>
            <h2 style={{ color: '#FA870B', margin: '0px' }}>News</h2>
         </Box>
         <Box
            sx={{
               mt: '10px',
               borderTop: '5px solid #FA870B',
               bgcolor: 'white',
               borderBottomRightRadius: '5px',
               borderBottomLeftRadius: '5px',
               overflow: 'auto',
               p: '10px',
            }}
            dangerouslySetInnerHTML={{ __html: newsContent }}
         />
      </Box>
   )
}
